var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile_banner"},[_c('Carousel',_vm._b({},'Carousel',_vm.carouselProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }